import React, { useEffect, useState } from "react";
import Team from "../Team/Team";
import "./Main.css";
const Main = (props) => {
  const [players, setPlayer] = useState([]);
  const [team, setTeam] = useState([]);
  useEffect(() => {
    setPlayer(props.playerlist);
  }, []);

  const addPlayer = (player) => {
      const newTeam = [...team, player]
      setTeam(newTeam)
  };
  return (
    <>
    {/* All players details information is show by this component*/}

      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-9">
            <div className="player-container">
              {players.map((player) => {
                return (
                  <div key={player.identifier} className="card shadow">
                    <img src={player.image} className="card-img-top" alt="" />
                    <div className="card-body text-center">
                      <h5 className="card-title">
                        {player.first_name} {player.last_name}
                      </h5>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                          Team : {player.team}
                        </li>
                        <li className="list-group-item">
                          Position : {player.position}
                        </li>
                        <li className="list-group-item">
                          Average salary : $ {player.average_salary}
                        </li>
                      </ul>
                      <button
                        onClick={() => addPlayer(player)}
                        className="btn btn-primary"
                      >
                        <i className="fa fa-plus"></i> Add Player
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-md-3 team">
            <div className="team-container">
              <Team team={team}></Team>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
